var map = {
	"./img-claim-active.png": "0363",
	"./img-claim.png": "acbf",
	"./img-flexibleWelfare-active.png": "4cda",
	"./img-flexibleWelfare.png": "fd64",
	"./img-health-active.png": "74b6",
	"./img-health.png": "dfa3",
	"./img-insuranceContract-active.png": "297f",
	"./img-insuranceContract.png": "a0df",
	"./img-integralManage-active.png": "50b9",
	"./img-integralManage.png": "e73b",
	"./img-saveManage-active.png": "e0e7",
	"./img-saveManage.png": "5e92",
	"./img-staffAccountmanage-active.png": "8fbe",
	"./img-staffAccountmanage.png": "c56e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d6043";